import { Sorter, SorterDirection } from '@common/services';
import React, { useEffect, useState } from 'react';
import { SortingIcon } from './components/SortingIcon';
import './fc-table-header.css';

export const FcTableHeader = ({
                                title,
                                sorting,
                                direction,
                                onSorterDirectionChange,
                                field,
                                activeSorter,
                              }: FcTableHeaderProps) => {
  const [selectedSorterDirection, setSelectedSorterDirection] = useState<SorterDirection | null>(direction);

  useEffect(() => {
    if (!sorting || direction === undefined) return;
    setSelectedSorterDirection(direction);
  }, [direction]);

  useEffect(() => {
    if (!sorting) return;
    if ((selectedSorterDirection === null) && (activeSorter?.direction !== undefined) && (activeSorter?.field !== field)) return;

    onSorterDirectionChange?.(selectedSorterDirection);
  }, [selectedSorterDirection]);

  const handleFilterChange = () => {
    setSelectedSorterDirection((prev) => {
      if (prev === null) return 'asc';
      if (prev === 'asc') return 'desc';
      return null;
    });
  };

  return (
    <div style={{ display: 'flex' }}>
      <div className={`fc-table-header ${(sorting) ? 'cursor-pointer' : ''}`}
           onClick={() => (sorting) && handleFilterChange()}>
        <span className={'fc-table-header--text color-primary'}>{title}</span>
        {(sorting) && (
          <div className={'fc-table-header--icon'}>
            <SortingIcon direction={selectedSorterDirection} />
          </div>
        )}
      </div>
    </div>
  );
};

export interface FcTableHeaderProps {
  title: string;
  /**
   * @default false
   */
  sorting?: boolean;
  /**
   * Changer la clé de tri du Sorter pour cette colonne
   * @default field
   */
  sortingKey?: string;
  field: string;
  activeSorter?: Sorter | null;
  direction: SorterDirection | null;
  onSorterDirectionChange?: (direction: SorterDirection | null) => void;
}
